
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F"}},[_c('rect',{staticClass:"i-stroke",attrs:{"width":"14","height":"14","x":"1.5","y":"1.5","rx":"1"}}),_c('rect',{staticClass:"i-stroke_2",attrs:{"width":"4","height":"6","x":"9.5","y":"7.5","rx":"1"}})])])
          )
        }
      }
    